/* VitalSpark Shop - Theme JS */
(function() {
  'use strict';

  // Cart drawer
  function initCartDrawer() {
    var overlay = document.getElementById('cart-overlay');
    var drawer  = document.getElementById('cart-drawer');
    var opens   = document.querySelectorAll('[data-cart-open]');
    var close   = document.querySelector('[data-cart-close]');

    function openCart() {
      if (!overlay || !drawer) return;
      overlay.classList.add('open');
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeCart() {
      if (!overlay || !drawer) return;
      overlay.classList.remove('open');
      drawer.classList.remove('open');
      document.body.style.overflow = '';
    }

    opens.forEach(function(el) { el.addEventListener('click', openCart); });
    if (close) close.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);
  }

  // Mobile menu
  function initMobileMenu() {
    var btn   = document.getElementById('mobile-menu-btn');
    var menu  = document.getElementById('mobile-menu');
    var close = document.getElementById('mobile-menu-close');
    if (!btn || !menu) return;

    btn.addEventListener('click', function() { menu.classList.toggle('open'); });
    if (close) close.addEventListener('click', function() { menu.classList.remove('open'); });
  }

  // Quantity stepper
  function initQtyStepper() {
    document.querySelectorAll('.qty-stepper').forEach(function(el) {
      var input = el.querySelector('input');
      var dec   = el.querySelector('[data-dec]');
      var inc   = el.querySelector('[data-inc]');
      if (!input) return;

      function update(val) {
        var n = Math.max(1, parseInt(input.value) + val);
        input.value = n;
      }
      if (dec) dec.addEventListener('click', function() { update(-1); });
      if (inc) inc.addEventListener('click', function() { update(1); });
    });
  }

  // Variant selector
  function initVariants() {
    document.querySelectorAll('.variant-btn, .color-swatch').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('.variant-options');
        if (group) group.querySelectorAll('.variant-btn, .color-swatch').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  }

  // Product image gallery
  function initGallery() {
    var main   = document.getElementById('product-main-img');
    var thumbs = document.querySelectorAll('.product-thumb');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        main.src = thumb.src;
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  // Tab switcher
  function initTabs() {
    document.querySelectorAll('.tab-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var parent = btn.closest('[data-tabs]');
        if (!parent) return;
        var target = btn.dataset.tab;

        parent.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
        parent.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.add('hidden'); });
        btn.classList.add('active');
        var panel = parent.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.remove('hidden');
      });
    });
  }

  // Toast notification
  window.showToast = function(msg) {
    var toast = document.getElementById('add-toast');
    if (!toast) return;
    toast.querySelector('.toast-msg').textContent = msg;
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 3000);
  };

  // Add to cart button feedback
  function initAddToCart() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var original = btn.textContent;
        btn.textContent = 'Added ✓';
        btn.disabled = true;
        window.showToast('Item added to your cart');
        setTimeout(function() { btn.textContent = original; btn.disabled = false; }, 2000);
      });
    });
  }

  // Sticky header shadow on scroll
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', function() {
      if (window.scrollY > 8) {
        header.style.boxShadow = '0 4px 24px rgba(0,0,0,0.4)';
      } else {
        header.style.boxShadow = '';
      }
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initCartDrawer();
    initMobileMenu();
    initQtyStepper();
    initVariants();
    initGallery();
    initTabs();
    initAddToCart();
    initStickyHeader();
  });
})();
